import { observer } from "mobx-react";
import React from "react";
import { IApplicationFilterComponent } from "../BaseFilterComponents/IApplicationFilterComponent";
import {
    DateRangeLabel,
    basicDateReferenceOptions,
} from "stores/ComponentStores/DatePickerComponentStore";
import AcxDateRangeInput from "components/UI/Calendar/DateRange/AcxDateRangeInput";
import { Moment } from "moment";

export const DateRangeFilter = observer(function ({
    store,
    onSelect,
    onDateRangeLabelChange,
    onClear,
    ...props
}: IApplicationFilterComponent &
    Omit<
        React.ComponentProps<typeof AcxDateRangeInput>,
        "datePickerStore" | "defaultStartDate" | "defaultEndDate"
    > & { viewOnly?: boolean }) {
    if (!store.datePickerStore) {
        console.warn(
            "Attempted to render a date range filter with no date picker store defined.",
        );
        return null;
    }

    return (
        <AcxDateRangeInput
            hideLabel
            sideBar
            doubleCalendar
            dateReferenceOptions={basicDateReferenceOptions}
            maxWidth={"375px"}
            wrapperStyle={{ maxWidth: "375px", minWidth: "350px" }}
            {...props}
            datePickerStore={store.datePickerStore}
            defaultStartDate={store.datePickerStore.beginDate.startOf("day")}
            defaultEndDate={store.datePickerStore.endDate}
            onSelect={(start: Moment, end: Moment) => {
                store.setStartDate(start);
                store.setEndDate(end);
                onSelect?.(start, end);
            }}
            onDateRangeLabelChange={(dateRangeLabel: DateRangeLabel) => {
                store.setDateRangeLabel(dateRangeLabel);
                onDateRangeLabelChange?.(dateRangeLabel);
            }}
            onClear={onClear}
            dateRangeLabel={store.dateRangeLabel}
        />
    );
});
